<template>
  <div
    class="save-solution"
    @keydown.stop.enter="apply"
  >
    <GwInput
      :placeholder="$t('common.new_tree_name')"
      type="text"
      autofocus
      :getErrors="
        () => (nameError ? [$t(`messages.${nameError}`, { max_chars: nameMaxChars })] : [])
      "
      :value="l_preset.name"
      @input="(_e, value) => (l_preset.name = value)"
      @keydown:enter="apply"
    />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { SNK } from '@/helpers/helpers'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'SolfigrSaveTree',
  components: { GwInput },
  mixins: [format_mix],
  props: {
    namespace: { String, required: true },
    action: String,
  },
  data() {
    return {
      l_preset: null,
      nameError: false,
      nameMaxChars: 200,
    }
  },
  created() {
    this.l_preset = { ...this.$store.getters[SNK(`slfrm_selectedTree`, this.namespace)] }
  },
  methods: {
    getNameError() {
      let res = false
      this.nameError = false
      // this.l_preset.name = this.l_preset.name.trim()
      if (this.l_preset.name.trim().length > this.nameMaxChars) {
        this.nameError = 'custom_solution_preset_name_too_many_characters'
        res = true
      }
      return res
    },
    apply() {
      if (this.getNameError()) return

      if (!this.l_preset.name.length) {
        this.nameError = 'custom_solution_name_empty_error'
        return
      }

      const solSettings = {
        ...this.l_preset,
        name: this.l_preset.name.trim(),
      }
      const { id } = this.l_preset

      const method = id ? 'patch' : 'post'

      this.$store.dispatch('api_poker_custom_user_trees_set', {
        hasMessage: true,
        data: solSettings,
        method,
        id,
        action: SNK('slfrm_handleApiTreeUpdate', this.namespace),
        actionArgs: {
          namespace: this.namespace,
          method,
          dialogs: ['solfigr-save-tree-dialog'],
        },
      })
    },
  },
  watch: {
    'l_preset.name': function () {
      this.getNameError()
    },
  },
}
</script>

<style lang="scss">
.save-solution {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 32rem;
  max-width: 100%;
}
</style>
